import { Stack } from '@mui/material'
import PageContainer from '@/components/ui/containers/PageContainer'
import { AdminEstablishmentTabEnum, useEstablishmentTab } from '../model/useEstablishmentTab'
import { EditEstablishment } from './EditEstablishment'
import { EstablishmentTabs } from './EstablishmentTabs'
import PluginsPage from '../../plugins/PluginsPage'

export function EstablishmentPage() {
  const [tab] = useEstablishmentTab()

  return (
    <PageContainer>
      <Stack spacing={2}>
        <EstablishmentTabs />
        {tab === AdminEstablishmentTabEnum.EDIT && <EditEstablishment />}
        {tab === AdminEstablishmentTabEnum.PLUGINS && <PluginsPage />}
      </Stack>
    </PageContainer>
  )
}
